// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3proT","boxTitle":"Qualiphy_boxTitle__3DekY","box":"Qualiphy_box__AStMK","toggleWrap":"Qualiphy_toggleWrap__1-9J0"};